import "babel-polyfill";
import 'whatwg-fetch';
import Vue from "vue";
import VueMeta from 'vue-meta';
import Vuex from "vuex";
import store from "./store";
import App from "./views/App";
import router from "./router";
import VueLodash from "vue-lodash";
import BootstrapVue from "bootstrap-vue";
import Notifications from "vue-notification";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faGem } from "@fortawesome/free-solid-svg-icons/faGem";
import { faSync } from "@fortawesome/free-solid-svg-icons/faSync";
import { faStar } from "@fortawesome/free-solid-svg-icons/faStar";
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus";
import { faMinus } from "@fortawesome/free-solid-svg-icons/faMinus";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons/faSignOutAlt";
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons";
import { faGem as farGem } from "@fortawesome/free-regular-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons/faEnvelope";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons/faCaretDown";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons/faPencilAlt";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons/faCalendarAlt";
import MaterialMD from "vue-material";
import "vue-material/dist/vue-material.min.css";
import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
import "vue-search-select/dist/VueSearchSelect.css";
import "@/mixins/cache";
import SKLoader from "@/components/SKLoader";
import VueGtag from "vue-gtag";
import VueCompositionAPI from '@vue/composition-api';

library.add(
    faSync,
    faPlus,
    faMinus,
    faEnvelope,
    faPencilAlt,
    faCaretDown,
    faCalendarAlt,
    faStar,
    faGem,
    farStar,
    farGem,
    faSearch,
    faSignOutAlt
);
Vue.use(MaterialMD);
Vue.use(VueLodash);
Vue.use(BootstrapVue);
Vue.use(Vuex);
Vue.use(Notifications);
Vue.use(PerfectScrollbar);
Vue.use(VueMeta);
Vue.use(VueCompositionAPI);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("SKLoader", SKLoader);
Vue.use(VueGtag, {
    config: { id: "G-3XV0602D1Q" }
}, router);
require("./bootstrap");

new Vue({
    router,
    store,
    components: {
        App
    }
}).$mount("#app");
